/**
 * Agent display config for the chat UI. No React component should hardcode
 * "Fen" or "Root Fen" — everything reads from here. Eventually this becomes
 * a fetch from the backend's agent resolver response.
 */

export interface AgentConfig {
  displayName: string;
  greeting?: string;
}

export function getAgentConfig(): AgentConfig {
  return {
    displayName: 'Fen',
    greeting: 'What can I help with?',
  };
}
